import { render, staticRenderFns } from "./AppQuestionIcon.vue?vue&type=template&id=14cb9ca2"
import script from "./AppQuestionIcon.vue?vue&type=script&lang=js"
export * from "./AppQuestionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports